import React from 'react'

export default function Footer() {
    return (
        <footer>
            <div className="footer-content">
                <div className="footer-column">
                    <div className="footer-socials">
                        {/* Instagram Icon */}
                        <a href="https://www.instagram.com/mirumpharma/" target="_blank" aria-label="Visit instagram.com/mirumpharma/ (opens in a new window)" title="Instagram">
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                //xmlns:xlink="http://www.w3.org/1999/xlink" 
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 56.7 56.7" 
                                enableBackground="new 0 0 56.7 56.7" 
                                //xml:space="preserve"
                                xmlSpace="preserve"
                                
                            >
                                <g>
                                    <path 
                                        d="M28.2,16.7c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8S41,36.5,41,29.5S35.2,16.7,28.2,16.7z M28.2,37.7 c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2S32.7,37.7,28.2,37.7z" 
                                        fill="#0e1628"
                                    ></path>
                                    <circle 
                                        cx="41.5" 
                                        cy="16.4" 
                                        r="2.9" 
                                        fill="#0e1628"
                                    ></circle>
                                    <path 
                                        d="M49,8.9c-2.6-2.7-6.3-4.1-10.5-4.1H17.9c-8.7,0-14.5,5.8-14.5,14.5v20.5c0,4.3,1.4,8,4.2,10.7c2.7,2.6,6.3,3.9,10.4,3.9 h20.4c4.3,0,7.9-1.4,10.5-3.9c2.7-2.6,4.1-6.3,4.1-10.6V19.3C53,15.1,51.6,11.5,49,8.9z M48.6,39.9c0,3.1-1.1,5.6-2.9,7.3 s-4.3,2.6-7.3,2.6H18c-3,0-5.5-0.9-7.3-2.6C8.9,45.4,8,42.9,8,39.8V19.3c0-3,0.9-5.5,2.7-7.3c1.7-1.7,4.3-2.6,7.3-2.6h20.6 c3,0,5.5,0.9,7.3,2.7c1.7,1.8,2.7,4.3,2.7,7.2V39.9L48.6,39.9z" 
                                        fill="#0e1628"
                                    ></path>
                                </g>
                            </svg>
                        </a>
                        
                        {/* LinkedIn */}
                        <a href="https://www.linkedin.com/company/mirum-pharmaceuticals" target="_blank" aria-label="Visit linkedin.com/company/mirum-pharmaceuticals (opens in a new window)" title="LinkedIn">
                            <svg 
                                height="512" 
                                viewBox="0 0 512 512" 
                                width="512" 
                                xmlSpace="preserve" 
                                xmlns="http://www.w3.org/2000/svg" 
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                                <g><g><g>
                                    <rect 
                                        height="328.97" 
                                        fill="#0e1628"
                                        width="106.716"
                                        x="17.397"
                                        y="166.28"
                                    ></rect>
                                    <path
                                        d="M414.789,170.138c-1.133-0.355-2.207-0.743-3.396-1.078c-1.438-0.327-2.865-0.6-4.328-0.833     c-5.662-1.139-11.875-1.946-19.148-1.946c-62.211,0-101.678,45.372-114.674,62.894V166.28H166.526v328.97h106.716V315.813 c0,0,80.643-112.628,114.674-29.911V495.25h106.688V273.257C494.604,223.549,460.629,182.13,414.789,170.138L414.789,170.138z  M414.789,170.138" 
                                        fill="#0e1628"
                                    ></path>
                                    <path 
                                        d="M121.789,69.085c0,28.909-23.373,52.337-52.195,52.337c-28.824,0-52.196-23.429-52.196-52.337 c0-28.903,23.372-52.335,52.196-52.335C98.416,16.75,121.789,40.182,121.789,69.085L121.789,69.085z M121.789,69.085" 
                                        fill="#0e1628"
                                    ></path>
                                </g></g></g>
                                <g id="Layer_1"></g>
                            </svg>
                        </a>
                        
                        {/* Twitter */}
                        <a href="https://twitter.com/mirumpharma" target="_blank" aria-label="Visit twitter.com/mirumpharma (opens in a new window)" title="Twitter">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1200" height="1227" viewBox="0 0 1200 1227" fill="none"><g clipPath="url(#clip0_1_2)"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="#0e1628"></path></g></svg>
                        </a>

                        {/* Facebook */}
                        <a href="https://www.facebook.com/mirumpharma" target="_blank" aria-label="Visit facebook.com/mirumpharma (opens in a new window)" title="Facebook">
                            <svg height="56" viewBox="0 0 56.693 56.693" width="56" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><path d="M40.43,21.739h-7.645v-5.014c0-1.883,1.248-2.322,2.127-2.322c0.877,0,5.395,0,5.395,0V6.125l-7.43-0.029  c-8.248,0-10.125,6.174-10.125,10.125v5.518h-4.77v8.53h4.77c0,10.947,0,24.137,0,24.137h10.033c0,0,0-13.32,0-24.137h6.77  L40.43,21.739z" fill="#0e1628"></path></svg>
                        </a>
                    </div>
                    
                    <div className="footer-links mt20">
                        <a href="https://mirumpharma.com/contact/" target="_blank" aria-label="Contact Us (opens in a new window)" title="Contact Us">Contact Us</a>
                        <a href="https://mirumpharma.com/terms-of-use/" target="_blank" aria-label="Terms of Use (opens in a new window)" title="Terms of Use">Terms of Use</a>
                        <a href="https://mirumpharma.com/privacy-policy/" target="_blank" aria-label="Privacy Policy (opens in a new window)" title="Privacy Policy">Privacy Policy</a>
                        <a href="https://mirumpharma.com/ca-tiscad/" target="_blank" aria-label="CA TISCAD (opens in a new window)" title="CA TISCAD">CA TISCAD</a>
                    </div>

                    <div className="mt20">
                        &copy; 2025 - Mirum Pharmaceuticals, Inc.<br/>
                        All rights reserved. US-CORP-2500015&nbsp;&nbsp;10/2025
                    </div>
                </div>
                <div className="footer-column">
                    <img src="./images/secondary-logo.png" alt=""  />
                </div>
            </div>

        </footer>
    )
}
